import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Session } from './session.model';
import { HttpErrorResponse } from '@angular/common/http';

export const SessionActions = createActionGroup({
  source: 'Session API',
  events: {
    'Load Session': emptyProps(),
    'Load Session Success': props<{ session: Session }>(),
    'Load Session Failure': props<{ error: HttpErrorResponse }>(),
  },
});
